const GPT_MODEL = {
    O4_MINI: 'o4-mini',
    O3_MINI: 'o3-mini',
    GPT_4O: 'gpt-4o',
    GPT_4_1: 'gpt-4.1',
    GPT_5: 'gpt-5',
    GPT_5_2: 'gpt-5.2',
    GPT_5_4: 'gpt-5.4',
    GPT_5_4_MINI: 'gpt-5.4-mini',
    GPT_5_5: 'gpt-5.5',
    GPT_5_6_SOL: 'gpt-5.6-sol',
    GPT_5_6_TERRA: 'gpt-5.6-terra',
    GPT_5_6_LUNA: 'gpt-5.6-luna',
    GPT_6_ASTRA: 'gpt-6-astra',
}

const GPT_MODEL_SETTING = {
    GPT_4O: {
        KEY: 'gpt-4o',
        VALUE: 'gpt-4o',
        TAG: 'field_chatgpt_model_ai_auto_tag_4o'
    },
    O3_MINI: {
        KEY: 'o3-mini',
        VALUE: 'o3-mini',
        TAG: 'field_chatgpt_model_ai_auto_tag_o3'
    },
    O4_MINI: {
        KEY: 'o4-mini',
        VALUE: 'o4-mini',
        TAG: 'field_chatgpt_model_ai_auto_tag_o4' 
    },
    GPT_4_1:{
        KEY: 'gpt-4.1',
        VALUE: 'gpt-4.1',
        TAG: 'field_chatgpt_model_ai_auto_tag_41'
    },
    GPT_5:{
        KEY: 'gpt-5',
        VALUE: 'gpt-5',
        TAG: 'field_chatgpt_model_ai_auto_tag_5'
    },
    GPT_5_2:{
        KEY: 'gpt-5.2',
        VALUE: 'gpt-5.2',
        TAG: 'field_chatgpt_model_ai_auto_tag_52'
    },
    GPT_5_4:{
        KEY: 'gpt-5.4',
        VALUE: 'gpt-5.4',
        TAG: 'field_chatgpt_model_ai_auto_tag_54'
    },
    GPT_5_4_MINI:{
        KEY: 'gpt-5.4-mini',
        VALUE: 'gpt-5.4-mini',
        TAG: 'field_chatgpt_model_ai_auto_tag_54_mini'
    },
    GPT_5_5:{
        KEY: 'gpt-5.5',
        VALUE: 'gpt-5.5',
        TAG: 'field_chatgpt_model_ai_auto_tag_55'
    },
    GPT_5_6_SOL: {
        KEY: 'gpt-5.6-sol',
        VALUE: 'gpt-5.6-sol',
        TAG: 'field_chatgpt_model_ai_auto_tag_56_sol'
    },
    GPT_5_6_TERRA: {
        KEY: 'gpt-5.6-terra',
        VALUE: 'gpt-5.6-terra',
        TAG: 'field_chatgpt_model_ai_auto_tag_56_terra'
    },
    GPT_5_6_LUNA: {
        KEY: 'gpt-5.6-luna',
        VALUE: 'gpt-5.6-luna',
        TAG: 'field_chatgpt_model_ai_auto_tag_56_luna'
    },
    GPT_6_ASTRA: {
        KEY: 'gpt-6-astra',
        VALUE: 'gpt-6-astra',
        TAG: 'field_chatgpt_model_ai_auto_tag_6_astra'
    }
}

const REASONING_EFFORT_OPTIONS = {
        NONE: {
            KEY: 'none',
            VALUE: 'none',
            TAG: 'field_reasoning_effort_ai_auto_none'
        },
        MINIMAL: {
            KEY: 'minimal',
            VALUE: 'minimal',
            TAG: 'field_reasoning_effort_ai_auto_minimal'
        },
        LOW: {
            KEY: 'low',
            VALUE: 'low',
            TAG: 'field_reasoning_effort_ai_auto_low'
        },
        MEDIUM: {
            KEY: 'medium',
            VALUE: 'medium',
            TAG: 'field_reasoning_effort_ai_auto_medium' 
        },
        HIGH:{
            KEY: 'high',
            VALUE: 'high',
            TAG: 'field_reasoning_effort_ai_auto_high'
        },
        XHIGH: {
            KEY: 'xhigh',
            VALUE: 'xhigh',
            TAG: 'field_reasoning_effort_ai_auto_xhigh'
        },
        MAX: {
            KEY: 'max',
            VALUE: 'max',
            TAG: 'field_reasoning_effort_ai_auto_max'
        },
};

/**
 * Check if model supports multimodal input (image upload/analysis).
 * gpt-4o, gpt-4.1, gpt-5.2, gpt-5.4, gpt-5.4-mini: always supported.
 * gpt-5: supported only when reasoning effort is not MINIMAL.
 * Note: This is different from image generation capability.
 */
const isSupportMultiModal = (chatGptModel, usingReasoningEffort) => {
    if (
        [
            GPT_MODEL.GPT_4O,
            GPT_MODEL.GPT_4_1,
            GPT_MODEL.GPT_5_2,
            GPT_MODEL.GPT_5_4,
            GPT_MODEL.GPT_5_4_MINI,
            GPT_MODEL.GPT_5_5,
            GPT_MODEL.GPT_5_6_SOL,
            GPT_MODEL.GPT_5_6_TERRA,
            GPT_MODEL.GPT_5_6_LUNA,
            GPT_MODEL.GPT_6_ASTRA
        ].includes(chatGptModel)
    )
        return true;
    
    if (chatGptModel === GPT_MODEL.GPT_5) {
        if (!usingReasoningEffort) return false;
        
        const isSelectMinimal = usingReasoningEffort === REASONING_EFFORT_OPTIONS.MINIMAL.VALUE;
        return !isSelectMinimal;
    }
    
    return false;
};

/**
 * Check if model supports image generation tool.
 * gpt-5.4-mini: supports multimodal input (image analysis) but NOT image generation.
 */
const isSupportImageGeneration = (chatGptModel, usingReasoningEffort) => {
    // gpt-5.4-mini does NOT support image generation
    if (chatGptModel === GPT_MODEL.GPT_5_4_MINI) {
        return false;
    }
    // Other models: use same logic as multimodal support
    return isSupportMultiModal(chatGptModel, usingReasoningEffort);
};

/**
 * Get list of ChatGPT models from corporation detail setting.
 */
const getListChatGptModelFromCorpDetail = (corporationDetail, isOriginList = false) => {
    try {
        const setting = JSON.parse(corporationDetail?.corporationSetting || "{}");
        const models = Array.isArray(setting.listChatGptModel) ? setting.listChatGptModel : [];
        if (isOriginList) {
            return models;
        }
        return models.filter(m => m?.id).map(m => ({ id: m.id, name: m.id }))
    } catch {
        return [];
    }
};

/**
 * Get allowed reasoning effort option values for a given model.
 * gpt-5: MINIMAL, LOW, MEDIUM, HIGH.
 * gpt-5.6 models: NONE, LOW, MEDIUM, HIGH, XHIGH, MAX.
 * gpt-6-astra: LOW, MEDIUM, HIGH, XHIGH, MAX (no NONE/MINIMAL).
 * gpt-5.2/gpt-5.4/gpt-5.4-mini/gpt-5.5: NONE, LOW, MEDIUM, HIGH, XHIGH.
 * Other/null: empty array (no options).
 */
const getReasoningEffortOptionsForModel = modelId => {
    if (modelId === GPT_MODEL.GPT_5) {
        return [
            REASONING_EFFORT_OPTIONS.MINIMAL.VALUE,
            REASONING_EFFORT_OPTIONS.LOW.VALUE,
            REASONING_EFFORT_OPTIONS.MEDIUM.VALUE,
            REASONING_EFFORT_OPTIONS.HIGH.VALUE
        ];
    }

    if (modelId === GPT_MODEL.GPT_6_ASTRA) {
        return [
            REASONING_EFFORT_OPTIONS.LOW.VALUE,
            REASONING_EFFORT_OPTIONS.MEDIUM.VALUE,
            REASONING_EFFORT_OPTIONS.HIGH.VALUE,
            REASONING_EFFORT_OPTIONS.XHIGH.VALUE,
            REASONING_EFFORT_OPTIONS.MAX.VALUE
        ];
    }

    if ([GPT_MODEL.GPT_5_6_SOL, GPT_MODEL.GPT_5_6_TERRA, GPT_MODEL.GPT_5_6_LUNA].includes(modelId)) {
        return [
            REASONING_EFFORT_OPTIONS.NONE.VALUE,
            REASONING_EFFORT_OPTIONS.LOW.VALUE,
            REASONING_EFFORT_OPTIONS.MEDIUM.VALUE,
            REASONING_EFFORT_OPTIONS.HIGH.VALUE,
            REASONING_EFFORT_OPTIONS.XHIGH.VALUE,
            REASONING_EFFORT_OPTIONS.MAX.VALUE
        ];
    }

    if ([GPT_MODEL.GPT_5_2, GPT_MODEL.GPT_5_4, GPT_MODEL.GPT_5_4_MINI, GPT_MODEL.GPT_5_5].includes(modelId)) {
        return [
            REASONING_EFFORT_OPTIONS.NONE.VALUE,
            REASONING_EFFORT_OPTIONS.LOW.VALUE,
            REASONING_EFFORT_OPTIONS.MEDIUM.VALUE,
            REASONING_EFFORT_OPTIONS.HIGH.VALUE,
            REASONING_EFFORT_OPTIONS.XHIGH.VALUE
        ];
    }

    return [];
};

/**
 * Resolve model name value from system tag. Returns null if not found.

 */
const getModelIdFromTagSysField = (sysField) => {
    if (!sysField) return null;

    const options = GPT_MODEL_SETTING;

    for (const key in options) {
        if (options[key].TAG === sysField) {
            return options[key].VALUE;
        }
    }

    return null;
};


/**
 * Validate reasoning effort option compatibility with gpt-5 family models.
 * gpt-5: NONE and XHIGH are not allowed.
 * gpt-5.2/gpt-5.4: MINIMAL is not allowed.
 */
const validateforGpt5 = (sysField, itemDataSystemField) => {
    const modelId = getModelIdFromTagSysField(sysField);
    if (!isGpt5Model(modelId)) return true;

    const selectedEffort = Object.values(REASONING_EFFORT_OPTIONS).find(
        option => option.TAG === itemDataSystemField
    );
    if (!selectedEffort) return false;

    return getReasoningEffortOptionsForModel(modelId).includes(selectedEffort.VALUE);
}

/**
 * Check if model belongs to gpt-5 family (gpt-5, gpt-5.2, gpt-5.4) by model name.
 */
const isGpt5Model = (chatGptModel) => {
    return [
        GPT_MODEL_SETTING.GPT_5.VALUE, 
        GPT_MODEL_SETTING.GPT_5_2.VALUE,
        GPT_MODEL_SETTING.GPT_5_4.VALUE,
        GPT_MODEL_SETTING.GPT_5_4_MINI.VALUE,
        GPT_MODEL_SETTING.GPT_5_5.VALUE,
        GPT_MODEL_SETTING.GPT_5_6_SOL.VALUE,
        GPT_MODEL_SETTING.GPT_5_6_TERRA.VALUE,
        GPT_MODEL_SETTING.GPT_5_6_LUNA.VALUE,
        GPT_MODEL_SETTING.GPT_6_ASTRA.VALUE
    ].includes(chatGptModel)
}

/**
 * Check if model belongs to gpt-5 family by system tag.
 */
const isSupportReasoningBySystemTag = (sysField) => {
    return [
        GPT_MODEL_SETTING.GPT_5.TAG, 
        GPT_MODEL_SETTING.GPT_5_2.TAG, 
        GPT_MODEL_SETTING.GPT_5_4.TAG, 
        GPT_MODEL_SETTING.GPT_5_4_MINI.TAG,
        GPT_MODEL_SETTING.GPT_5_5.TAG,
        GPT_MODEL_SETTING.GPT_5_6_SOL.TAG,
        GPT_MODEL_SETTING.GPT_5_6_TERRA.TAG,
        GPT_MODEL_SETTING.GPT_5_6_LUNA.TAG,
        GPT_MODEL_SETTING.GPT_6_ASTRA.TAG
    ].includes(sysField)
}

/**
 * Get default reasoning effort value by model.
 * gpt-5: MINIMAL
 * gpt-6-astra: LOW (no NONE support)
 * gpt-5.2/gpt-5.4/others: NONE
 */
const defaultReasoningEffort = (chatGptModel, isGetTagValue = false) => {
    if (chatGptModel === GPT_MODEL_SETTING.GPT_5.VALUE) {
        if (isGetTagValue) return REASONING_EFFORT_OPTIONS.MINIMAL.TAG;
        return REASONING_EFFORT_OPTIONS.MINIMAL.VALUE;
    }
    if (chatGptModel === GPT_MODEL_SETTING.GPT_6_ASTRA.VALUE) {
        if (isGetTagValue) return REASONING_EFFORT_OPTIONS.LOW.TAG;
        return REASONING_EFFORT_OPTIONS.LOW.VALUE;
    }
    if (isGetTagValue) return REASONING_EFFORT_OPTIONS.NONE.TAG;

    return REASONING_EFFORT_OPTIONS.NONE.VALUE;
}

/**
 * Get all reasoning effort system tags.
 */
const getReasoningEffortTags = () => {
    return Object.values(REASONING_EFFORT_OPTIONS).map(v => v.TAG)
}


/**
 * Check if model supports reasoning effort parameter. Only gpt-5 family models support it.
 */
const isSupportReasoning = (model) => {
     return [
        GPT_MODEL_SETTING.GPT_5.VALUE, 
        GPT_MODEL_SETTING.GPT_5_2.VALUE,
        GPT_MODEL_SETTING.GPT_5_4.VALUE,
        GPT_MODEL_SETTING.GPT_5_4_MINI.VALUE,
        GPT_MODEL_SETTING.GPT_5_5.VALUE,
        GPT_MODEL_SETTING.GPT_5_6_SOL.VALUE,
        GPT_MODEL_SETTING.GPT_5_6_TERRA.VALUE,
        GPT_MODEL_SETTING.GPT_5_6_LUNA.VALUE,
        GPT_MODEL_SETTING.GPT_6_ASTRA.VALUE
    ].includes(model)
}


const OpenAiUtil = {
    isSupportMultiModal,
    isSupportImageGeneration,
    getListChatGptModelFromCorpDetail,
    getReasoningEffortOptionsForModel,
    isGpt5Model,
    isSupportReasoningBySystemTag,
    defaultReasoningEffort,
    getReasoningEffortTags,
    isSupportReasoning,
    getModelIdFromTagSysField,
    validateforGpt5
};

export default OpenAiUtil;

